// @ts-ignore
import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";
import { JiraProductDiscoveryLogoBrand } from "@/libraries/wpl/foundations/src/logos/jiraproductdiscovery-logo-brand";
import { JiraSoftwareLogoBrand } from "@/libraries/wpl/foundations/src/logos/jirasoftware-logo-brand";
import { JiraWorkManagementLogoBrand } from "@/libraries/wpl/foundations/src/logos/jiraworkmanagement-logo-brand";

import { TryPageCard, TryPageHeader } from "../../components";
import { messages } from "../messages";

const sectionStyles = css({
    padding: "64px 0 32px",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const PlanAndTrackSection = () => {
    const intl = useIntl();

    const jiraSofttwareHeaderText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.title",
        defaultMessage: "Plan & Track"
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: "#0052cc"
    };

    const jiraSofttwareBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraSofttwareBody",
        defaultMessage:
            "Plan, track, and release world-class software with the #1 software development tool used by agile teams."
    });
    const jiraSofttwareLink = useLocalizedHref("/software/jira/free");

    const jiraWorkManagementBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraWorkManagementBody",
        defaultMessage:
            "Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos."
    });
    const jiraWorkManagementLink = useLocalizedHref(
        "/software/jira/work-management/free"
    );

    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody",
        defaultMessage:
            "Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira."
    });
    const jirProductDiscoveryLink = useLocalizedHref(
        "/try/cloud/signup?bundle=jira-product-discovery"
    );

    const tryCloud = intl.formatMessage(messages.tryCloud);
    const jiracardProps = {
        logo: <JiraSoftwareLogoBrand />,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jsmcardProps = {
        logo: <JiraWorkManagementLogoBrand />,
        link: jiraWorkManagementLink,
        bodyText: jiraWorkManagementBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: <JiraProductDiscoveryLogoBrand />,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return (
        <div css={sectionStyles}>
            <Row>
                <TryPageHeader {...headerProps} />
            </Row>
            <Row layout="6-6">
                <TryPageCard {...jiracardProps} />
                <TryPageCard {...jsmcardProps} />
            </Row>
            <div />
            <Row>
                <TryPageCard {...jpdcardProps} />
                <div />
            </Row>
        </div>
    );
};

export default PlanAndTrackSection;
